import { CSSProperties } from 'react';
import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';

export const ArrowTailIcon = ({
  className,
  style,
  color = Color.Gray900,
  size = 24,
}: {
  style?: CSSProperties;
  size?: number;
} & NewIconProps) => (
  <svg
    className={className}
    style={style}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0008 3.84437L20.1563 11.9998L18.753 13.4031L12.991 7.64117L12.991 20.1553L11.0106 20.1553L11.0106 7.64117L5.2345 13.4031L3.84535 11.9998L12.0008 3.84437Z"
      fill={color}
    />
  </svg>
);
